import { defaultGamerProfile, } from 'const/gamerProfiles'
import A from 'const/actionTypes'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'

export default {
  clearOtherGamerProfile: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_OTHER_GAMER_PROFILE, })
    }
  },
  setOtherGamerProfile: (gamerId) => {
    return (dispatch, getState) => {

      firebaseService.subscribe(
        'gamerProfiles/' + gamerId,
        (result) => {
          let otherGamerProfile = result.val()

          if (!otherGamerProfile) {
            otherGamerProfile = defaultGamerProfile
          }

          dispatch({
            type: A.SET_OTHER_GAMER_PROFILE,
            otherGamerProfile
          })
        },
        N.GAMERS
      )
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/otherGamerProfile.js